import * as React from "react";
import { SVGProps } from "react";
import { useLocation } from "react-router-dom";

const SettingsIcon = (props: SVGProps<SVGSVGElement>) => {
  const location = useLocation();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17.5}
      height={17.5}
      {...props}
    >
      <g
        fill="none"
        // stroke="#fff"
        stroke={
          location?.pathname.startsWith("/access/settings") &&
          !location?.pathname.startsWith("/access/notifications/settings")
            ? "white"
            : "#172B4D"
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        data-name="Component 6469 \u2013 3"
      >
        <path
          d="M7.261 1.921a1.532 1.532 0 0 1 2.978 0 1.532 1.532 0 0 0 2.287.948 1.533 1.533 0 0 1 2.107 2.107 1.532 1.532 0 0 0 .947 2.286 1.532 1.532 0 0 1 0 2.978 1.532 1.532 0 0 0-.948 2.287 1.533 1.533 0 0 1-2.107 2.107 1.532 1.532 0 0 0-2.286.947 1.532 1.532 0 0 1-2.978 0 1.532 1.532 0 0 0-2.287-.948 1.533 1.533 0 0 1-2.107-2.107 1.532 1.532 0 0 0-.947-2.286 1.532 1.532 0 0 1 0-2.978 1.532 1.532 0 0 0 .948-2.287 1.533 1.533 0 0 1 2.107-2.108 1.531 1.531 0 0 0 2.286-.947Z"
          data-name="Path 5911"
          stroke={
            location?.pathname.startsWith("/access/settings") &&
            !location?.pathname.startsWith("/access/notifications/settings")
              ? "white"
              : "#172B4D"
          }
        />
        <path
          d="M6.083 8.75A2.667 2.667 0 1 0 8.75 6.083 2.667 2.667 0 0 0 6.083 8.75"
          data-name="Path 5912"
          stroke={
            location?.pathname.startsWith("/access/settings") &&
            !location?.pathname.startsWith("/access/notifications/settings")
              ? "white"
              : "#172B4D"
          }
        />
      </g>
    </svg>
  );
};

export default SettingsIcon;
